import { isEmpty } from '../../../../../core/util/empty';
import { analyticsTrackEvent } from '../../../../../core/analytics';
import { Actions, Events } from '../../../util/analytics';
import history from '../../../../../core/history';
import {
  formatLocationNameFromBooking,
  isChildrenUrgentCareChicago,
  isDentalLocation,
  isTraditionalLocation,
  isUrgentCareForKids,
} from '../../../../../core/util/location';
import { ASAP_LABEL, ASAP_VALUE, TYPE_SELF } from '../../../../../constants/index';
import DateTime, { HOUR_MINUTE_PERIOD_DAY_MONTH_DAY_NUMBER } from '../../../../DateTime';
import { isMedicaid } from '../../../../../core/util/insurance';

const getAddress = (location: any) => {
  if (!isEmpty(location)) {
    return `${location.address} ${location.city}, ${location.state} ${location.zipCode}`;
  }

  return null;
};

const shouldShowAddInsurance = (bookingInsurerType: any, location: any) => {
  return (
    (!isTraditionalLocation(location) || isDentalLocation(location)) &&
    !(
      bookingInsurerType === TYPE_SELF ||
      isUrgentCareForKids(location.id) ||
      isChildrenUrgentCareChicago(location.id)
    )
  );
};

const shouldShowCostEstimate = (
  bookingHasInsuranceInfo: any,
  bookingInsurerType: any,
  location: any
) =>
  bookingHasInsuranceInfo &&
  shouldShowAddInsurance(bookingInsurerType, location) &&
  !isMedicaid(bookingInsurerType);

const getRowsProps = (
  booking: any,
  bookingHasInsuranceInfo: any,
  bookingInsurerType: any,
  location: any,
  userProfileId: any
) => {
  return [
    {
      text: 'View visit details',
      onClick: () => {
        analyticsTrackEvent(Events.UPCOMING_CARD, {
          action: Actions.CLICK_VIEW_VISIT_DETAILS,
        });

        history.push(`/pass/${booking.id}`);
      },
      shouldShow: true,
    },
  ];
};

const getAppointmentDate = (appointmentDate: any, bookingTimeZone: any, preferredTime?: any) => {
  if (preferredTime === ASAP_VALUE) {
    return ASAP_LABEL;
  }

  return DateTime.format(appointmentDate, bookingTimeZone)(HOUR_MINUTE_PERIOD_DAY_MONTH_DAY_NUMBER);
};

const getLocationName = (booking: any) => formatLocationNameFromBooking(booking).split(' - ')[0];

export { getAddress, getAppointmentDate, getLocationName, getRowsProps };
